/* global axios */
import ApiClient from './ApiClient';

class MessageReportsAPI extends ApiClient {
  constructor() {
    super('message_reports', { accountScoped: true });
  }

  getSummary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export const messageReportsAPI = new MessageReportsAPI();
